module.exports = __webpack_public_path__ + "img/inventory-logo.7b4a3cf0.png";